import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  getIssueById,
  getIssueDataById,
  getVolumeById,
  getVolumesDataById,
} from '../../../entity/volumes/Volumes'
import { useTranslation } from 'react-i18next'
import { getUserData } from '../../../entity/user/model/selector/getUserData/getUserData'
import CreateArticle from './CreateArticle/CreateArticle'
import SingleArticle from './SingleArticle/SingleArticle'
import { Helmet } from 'react-helmet'

const Content = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const { t } = useTranslation()

  const user = useSelector(getUserData, shallowEqual)

  useEffect(() => {
    if (params?.issueId && params?.volumeId) {
      dispatch(getIssueById(params?.issueId))
      dispatch(getVolumeById(params?.volumeId))
    }
  }, [dispatch, params])

  const volumeData = useSelector(getVolumesDataById, shallowEqual)
  const issueData = useSelector(getIssueDataById, shallowEqual)

  if (!volumeData) {
    return (
      <div className='grid place-items-center text-2xl text-[#002336] capitalize h-full'>
        {t('volume.noVolumes')}
      </div>
    )
  }

  if (!issueData)
    return (
      <div className='grid place-items-center text-2xl text-[#002336] capitalize h-full'>
        {t('volume.noIssues')}
      </div>
    )

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{t('volume.title')}</title>
        <link rel='canonical' href='http://moambe.org.ge/volumes' />
        <meta name='description' content='Moambe Journal - Scientific Journal of Georgian National Academy of Sciences. მოამბე - საქართველოს მეცნიერებათა ეროვნული აკადემიის სამეცნიერო ჟურნალი' />
        <meta property='og:title' content={t('volume.title')} />
        <meta property='og:description' content='Moambe Journal - Scientific Journal of Georgian National Academy of Sciences. მოამბე - საქართველოს მეცნიერებათა ეროვნული აკადემიის სამეცნიერო ჟურნალი' />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='http://moambe.org.ge/volumes' />
        <meta property='og:image' content='http://moambe.org.ge/og-image.jpg' />
        <meta property='og:site_name' content='Moambe Journal / მოამბე ჟურნალი' />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:title' content={t('volume.title')} />
        <meta property='twitter:description' content='Moambe Journal - Scientific Journal of Georgian National Academy of Sciences. მოამბე - საქართველოს მეცნიერებათა ეროვნული აკადემიის სამეცნიერო ჟურნალი' />
        <meta property='twitter:image' content='http://moambe.org.ge/og-image.jpg' />
        <meta property='twitter:url' content='http://moambe.org.ge/volumes' />
        <meta property='twitter:site' content='@moambe' />
        <meta property='twitter:creator' content='@moambe' />
      </Helmet>
      <div className='group flex flex-col'>
        <div className='flex flex-row gap-3 items-center text-4xl font-thin text-[#326383] text-wrap text-ellipsis overflow-hidden'>
          {t('volume.vol')}&nbsp;
          {volumeData?.volume || `NULL`}, {t('volume.issue')}&nbsp;{issueData?.number},&nbsp;
          {volumeData?.year || new Date().getFullYear()}
          {user?.role === 'admin' && (
            <CreateArticle volumeId={volumeData?.id} issueId={issueData?.id} />
          )}
        </div>
        {/* issues title is disabled */}
        {/* {issueData?.title && <div className='text-3xl text-[#002336] mt-4'>{issueData?.title}</div>} */}
        <div className='flex flex-col gap-4'>
          <div>
            {issueData?.articles?.map(article => (
              <SingleArticle key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Content
